import { useState, useEffect } from 'react';
import { Moon, Sun } from 'lucide-react';
import { useLocation } from 'react-router-dom';

export default function ThemeToggle({ className }) {
  const location = useLocation();
  const isDashboard = location.pathname === '/dashboard' || location.pathname === '/legal-library';
  const isHukmDomain = window.location.hostname.includes('hukm.cloud');

  const [isDark, setIsDark] = useState(() => {
    if (window.location.hostname.includes('hukm.cloud')) {
      return false;
    }

    // قراءة التفضيل المحفوظ أو تفضيل النظام
    const saved = localStorage.getItem('theme');
    if (saved) {
      return saved === 'dark';
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  // useEffect(() => {
  //   // تطبيق الوضع على العنصر الجذري
  //   if (isDark) {
  //     document.documentElement.classList.add('dark');
  //     localStorage.setItem('theme', 'dark');
  //   } else {
  //     document.documentElement.classList.remove('dark');
  //     localStorage.setItem('theme', 'light');
  //   }
  // }, [isDark]);
  useEffect(() => {
    // فرض الوضع الفاتح لنطاق حكم وحذف كلاس الـ dark
    if (isHukmDomain) {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
      return;
    }

    if (isDark) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [isDark, isHukmDomain]);

  // الاستماع لتغييرات تفضيل النظام
  useEffect(() => {
    if (isHukmDomain) return;

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      if (!localStorage.getItem('theme')) {
        setIsDark(e.matches);
      }
    };
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [isHukmDomain]);

  // إخفاء الزر العائم في لوحة التحكم
// if (isDashboard || (isHukmDomain && !className)) {
//     return null;
//   }

  if (isHukmDomain) {
    return null;
  }

  // إذا كنت تريد إخفاء الزر العائم أيضاً في النطاقات الأخرى داخل الـ dashboard
  if (isDashboard && !className) {
    return null;
  }

  return (
    <button
      onClick={() => setIsDark(!isDark)}
      className={className || "theme-toggle-btn"}
      data-testid="theme-toggle"
      title={isDark ? 'الوضع النهاري' : 'الوضع الليلي'}
    >
      {isDark ? (
        <Sun className="w-6 h-6" />
      ) : (
        <Moon className="w-6 h-6" />
      )}
    </button>
  );
}
